import { render, staticRenderFns } from "./proxyList.vue?vue&type=template&id=a97c2318&scoped=true&"
import script from "./proxyList.vue?vue&type=script&lang=js&"
export * from "./proxyList.vue?vue&type=script&lang=js&"
import style0 from "./proxyList.vue?vue&type=style&index=0&id=a97c2318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97c2318",
  null
  
)

export default component.exports